import create from 'zustand'

type TokenAmilState = {
  guideNumber: string
  setGuideNumber: (guideNumber) => void
}

export const useTokenAmil = create<TokenAmilState>(set => ({
  guideNumber: null,
  setGuideNumber: (guideNumber: string) => {
    set(() => ({
      guideNumber,
    }))
  },
}))
